module.exports = __webpack_public_path__ + "media/images/black-8ddac39b98fb65dc14d37f6712d94a56.png";